/**
 * Created by Administrator on 2019/2/2.
 */
import axios from 'axios';
// let baseProduceUrl = 'http://182.61.134.222/he/';
// let baseTestURL = 'http://182.61.134.222/he/';
let baseProduceUrl = 'http://39.103.131.97/he/';
let baseTestURL = 'http://39.103.131.97/he/';
// let baseProduceUrl = 'http://192.168.124.15:7704/he/';
// let baseTestURL = 'http://192.168.124.15:7704/he/';


/**
 * Method:post/get
 * URL:ajax url
 * Params:{'xx':'xx'}
 **/
export function httpRequest(method,url,params,contentType){
    if(contentType == ''){
        return axios({
            method: method,
            baseURL: process.env.NODE_ENV == 'development' ? baseTestURL:baseProduceUrl,
            url: url,
            params: params,
            headers: {'sessionId': localStorage.getItem('sessionId')}
        });
    }else{
        return axios({
            contentType: 'application/json',
            method: method,
            baseURL: process.env.NODE_ENV == 'development' ? baseTestURL:baseProduceUrl,
            url: url,
            data: params,
            headers: {'sessionId': localStorage.getItem('sessionId')}
        });
    }
}

export function httpRequestUpload (url){
    return (process.env.NODE_ENV == 'development' ? baseTestURL:baseProduceUrl)+url;
}

export const baseUrl = process.env.NODE_ENV == 'development' ? baseTestURL:baseProduceUrl;
//拦截请求
axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

//拦截响应
axios.interceptors.response.use(function (resp) {
    if(resp.data.code == '401'){
        location.href = '#/login'
    }else if(resp.data.status == '501'){
        localStorage.setItem('sessionId', '');
        localStorage.setItem('dataName', resp.data.msg);
        location.href = '#/500'
    }else{
        return resp.data;
    }

}, function (error) {
    if (error.response == null)
        error.message = '网络异常';
    return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/api/http.js